import React from 'react';

function Comment(props) {
  if (!props.comment) {
    return "";
  }
  return (
    <div>
      <textarea className="form-control" rows="3" readOnly
        value={props.comment} />
    </div>
  );
}

export default Comment;